import React from "react";
import Loader from "../../screens/Loader";
import { Modal } from "react-bootstrap";
import "./styles.scss";

export default function LoadingModal(props) {
  const { show } = props;
  return (
    <Modal className="loading-modal" show={show} centered>
      <Loader />
    </Modal>
  );
}
